import { Box, Typography } from '@mui/material';
import moment from 'moment';
import { pxToRem, responsiveFontSizes } from './utils/getFontValue';
import ClearIcon from '@mui/icons-material/Clear';
import config from './config/config';

export const ENV_TYPES = {
	TEST: 'TEST',
	PRODUCTION: 'PRODUCTION',
};

export const DARK_MODE = 'dark';
export const LIGHT_MODE = 'light';

export const APPLICATION_NAME = 'EP Assembly';

export const SCREEN_REFRESH_INTERVAL_TIME_MS = 60000;

export const AUTO_LOGOUT_TIME_MS = 60 * 60 * 1000; // 1 hour

export const COLUMNS_TO_HIDE_FOR_CHASSIS_LINE = ['displaySequenceNumber', 'partNumber', 'description']

export const CHASIS_LINE_IDS = [1011, 1012, 1005]

export const CONTINUESLY_API_CALLS = [
	"/station/parts?type=TAKEN_OUT", "/line/upcoming-parts"
]

export const DATE_FORMAT = {
	ISO: 'YYYY-MM-DD',
	ISO_DATE_FNS: 'yyyy-MM-dd',
	DAY_MONTH_YEAR: 'DD-MM-YYYY',
};

export const START_OF_DAY_TIME = 'T00:00:00';
export const END_OF_DAY_TIME = 'T23:59:59';

export const MAJOR_REPAIR_MOVE_OUT_REDIRECT_DELAY_MS = 1500;

export const MAJOR_REPAIR_API_PATHS = {
	ADD_TO_MR: '/station/add-to-mr',
	ALL_VEHICLES: '/mr/station/all-vehicles',
	VEHICLES_BY_TIME_RANGE: '/mr/station/vehicles-by-time-range',
	CLEAR_VIN: '/mr/station/clear-vin',
	RECEIVED_ASN: '/mr/station/received-asn',
	CURRENT_PART: '/mr/station/current-part-on-mr',
	DESTINATIONS: '/mr/station',
	MOVE_TO_LINE: '/mr/station/move-to-line',
};

export const MAJOR_REPAIR_MESSAGES = {
	ADD_TO_MR_REASON: 'Quality issue found, needs rework',
	MOVE_OUT_REASON: 'Repaired, resuming build',
	NOT_IN_FLIGHT: 'Vehicle/ASN is not currently in-flight at this station.',
	NO_ACTIVE_RECORD: 'No active Major Repair record found for this ASN (vehicle may have been returned to line).',
	DESTINATION_NOT_FOUND: "Couldn't find this vehicle in MR",
	MOVE_OUT_FAILED: 'Move Out failed. The vehicle may not be in MR or the selected station is not valid.',
	RECEIVE_ERROR: 'Error Receiving Vehicle',
	VEHICLE_NOT_IN_MR: 'Vehicle not found or not in MR.',
	MOVE_OUT_LOADING: 'Processing Move Out for Major Repair...',
	MOVE_OUT_SUCCESS: 'Move Out Completed Successfully',
	MOVE_OUT_ERROR: 'Move Out Failed',
	CLEAR_LOADING: 'Clearing current vehicle from Major Repair...',
	CLEAR_SUCCESS: 'Current vehicle cleared from the MR station.',
	CLEAR_ERROR: 'Unable to clear current vehicle',
	TRY_AGAIN: 'Please try again.',
};

export const MESSAGE_TYPE = {
	ERROR: 'Error',
	SUCCESS: 'Success',
	LOADING: 'Loading',
	TROUBLE: 'Trouble',
};

export const AT_STATION_TAB = 0;
export const UPCOMING_TAB = 1;
export const PROCESSED_TAB = 2;
export const NEW_PROCESSED_TAB = 3;


export const LOADING_MESSAGE = {
	SERIAL_NUMBER_CONTEXT_TEXT: 'Generating Serial Number',
	CHECKING_VIN_AVAILABLITY: 'Checking availability of VIN',
	CHECKING_STATION_STATUS: 'Checking station status...',
};

export const ERROR_MESSAGE = {
	ERROR_CONTEXT_TEXT: 'Error occured - ',
	SERIAL_NUMBER_ERROR_INFO_TEXT:
		'Contact local IPMS support team for resolution.',
	LANDING_PAGE_ERROR_MESSAGE:
		'Please wait as the station is  currently occupied by another order',
	MARK_COMPLETE_ERROR_MESSAGE: 'Could not mark complete',
	BOOKING_NOT_COMPLETE_MESSAGE: 'Booking not succesfully completed',
};

export const PRINTER_LOADING = {
	SERIAL_NUMBER_ERROR_CONTEXT_TEXT: 'Barcode printing in progress.',
};
export const PART_VALIDATION_LOADING = {
	SERIAL_NUMBER_ERROR_CONTEXT_TEXT: 'Initiating Station operation',
};

export const DEFAULT_MESSAGE = {
	ERROR: 'Fetching Details',
	SUCCESS: 'Operation Successfully Completed',
};

export const PRINTER_ERROR = {
	ERROR_CONTEXT_TEXT: 'Error occured - ',
	SERIAL_NUMBER_ERROR_INFO_TEXT: 'Try the following to resolve this issue.',
};

export const forbiddenChars = /[',<>|&{}]/g;

export const PART_VALIDATION_ERROR = {
	ERROR_CONTEXT_TEXT: 'Error occured - ',
	SERIAL_NUMBER_ERROR_INFO_TEXT: 'Try the following to resolve this issue.',
	PART_VALIDATION_COMPLETED:
		'Part Validation for this serial number is completed. Please use different part number.',
};

export const SCAN_ATTRIBUTE_ERROR = {
	ERROR_CONTEXT_TEXT: 'Error occured - ',
	SERIAL_NUMBER_ERROR_INFO_TEXT: 'Try the following to resolve this issue.',
	ATTRIBUTE_SCANNED_COMPLETED:
		'Attribute scanned for attribute is completed. Please use different attribute.',
};

export const PLATE_PUNCHING_FILE_PROCESSING = {
	FILE_CREATION_ERROR_CONTEXT_TEXT: 'Updating File',
};

export const PLATE_PUNCHING_FILE_CREATION_ERROR = {
	ERROR_CONTEXT_TEXT: 'Error occured - ',
	FILE_CREATION_ERROR_INFO_TEXT: 'Try the following to resolve this issue.',
};

export const ENGRAVING_FILE_CREATION_ERROR = {
	ERROR_CONTEXT_TEXT: 'Error occured - ',
	FILE_CREATION_ERROR_INFO_TEXT: 'Try the following to resolve this issue.',
};

export const EMPTY_PITCH_LOADING = {
	EMPTY_PITCH_CONTEXT_TEXT: 'Empty pitch in progress.',
};

export const SCANNED_VALUE_DATA_TYPES = {
	NUMBER: 'NUMBER',
	ALPHA_NUMERIC: 'ALPHA_NUMERIC',
	ALPHABET: 'ALPHABET',
	ANY: 'ANY'
}

// ZPL template used to print a barcode for a material/part number.
// Use string replacement to inject values for placeholders like {MaterialNumber}.
export const ZPL_TEMPLATE_FOR_BARCODE = `
^XA

^FO150,50^A0N,50,60^FD{Date}^FS
^FO600,50^A0N,50,60^FD{Time}^FS

^FO150,130^A0N,75,45^FD{PartNumber}^FS

^FO150,200
^BQN,2,9
^FDLA,{PartNumber}^FS

^XZ`;


export const ZPL_TEMPLATE_FOR_WTCL_PRINT = `
^XA
^PW1200
^LH60,0
^CF0,80

^FO50,80^FDPANAPAKKAM OPERATIONS^FS
^FO50,180^FDINDIA^FS

^BY4,3,120
^FO55,290^BCN,120,N,N,N
^FD{VIN}^FS

^CF0,54
^FO50,470^FDFULL VIN :-^FS
^FO440,470^FD{VIN}^FS

^FO50,550^FDENG NUMBER :-^FS
^FO440,550^FB740,1,0,L,0^FD{ENGINE_NUMBER}^FS

^FO50,630^FDMODEL :-^FS
^FO440,630^A0N,30,30^FB740,1,0,L,0^FD{MODEL}^FS

^CF0,54
^FO50,720^FDCOLOR :-^FS
^FO440,720^FD{COLOR}^FS

^FO50,800^FDTYPE OF SALE :-^FS
^FO440,800^FDSOLD^FS

^FO50,900^A0N,30,30^FDDISTRIBUTER :-^FS
^FO440,900^A0N,30,30^FB740,1,0,L,0^FDTATA MOTORS PASSENGER VEHICLES^FS

^FO900,970^A0N,30,30^FD{MONTH_YEAR}^FS
^XZ`;

// export const ZPL_TEMPLATE_FOR_WTCL_PRINT = `
// ^XA
// ^PW960
// ^LH0,0
// ^CF0,80
// ^FO50,80^FDPANAPAKKAM OPERATIONS^FS
// ^FO50,180^FDINDIA^FS
// ^BY4,3,120
// ^FO55,290^BCN,120,N,N,N
// ^FD{VIN}^FS
// ^CF0,54
// ^FO50,470^FDFULL VIN :-^FS
// ^FO470,470^FD{VIN}^FS
// ^FO50,560^FDENG NUMBER :-^FS
// ^FO470,560^FD{ENGINE_NUMBER}^FS
// ^FO50,630^FDMODEL :-^FS
// ^FO470,630^A0N,36,36^FD{MODEL}^FS^CF0,54
// ^FO50,740^FDCOLOR :-^FS
// ^FO470,740^FD{COLOR}^FS
// ^FO50,830^FDTYPE OF SALE :-^FS
// ^FO470,830^FDSOLD^FS
// ^FO760,890^FD{MONTH_YEAR}^FS
// ^FO50,960^A0N,30,30^FDDISTRIBUTER :-^FS
// ^FO470,960^A0N,30,30^FDTATA MOTORS PASSENGER VEHICLES^FS
// ^XZ`;
// export const ZPL_TEMPLATE_FOR_WTCL_PRINT = `
// ^XA
// ^PW1200
// ^LH0,0
// ^CF0,80
// ^FO50,80^FDPANAPAKKAM OPERATIONS^FS
// ^FO50,180^FDINDIA^FS
// ^BY4,3,120
// ^FO55,290^BCN,120,N,N,N
// ^FD{VIN}^FS
// ^CF0,54
// ^FO50,470^FDFULL VIN :-^FS
// ^FO380,470^FD{VIN}^FS
// ^FO50,560^FDENG NUMBER :-^FS
// ^FO380,560^FD{ENGINE_NUMBER}^FS
// ^FO50,630^FDMODEL :-^FS
// ^FO380,630^A0N,30,30^FB820,1,0,L,0^FD{MODEL}^FS^CF0,54
// ^FO50,740^FDCOLOR :-^FS
// ^FO380,740^FD{COLOR}^FS
// ^FO50,830^FDTYPE OF SALE :-^FS
// ^FO380,830^FDSOLD^FS
// ^FO950,890^FD{MONTH_YEAR}^FS
// ^FO50,960^A0N,30,30^FDDISTRIBUTER :-^FS
// ^FO380,960^A0N,30,30^FDTATA MOTORS PASSENGER VEHICLES^FS
// ^XZ`;

// export const ZPL_TEMPLATE_FOR_WTCL_PRINT = `
// ^XA
// ^PW960
// ^LH0,0
// ^CF0,80
// ^FO50,80^FDPANAPAKKAM OPERATIONS^FS
// ^FO50,180^FDINDIA^FS
// ^BY4,3,120
// ^FO55,290^BCN,120,N,N,N
// ^FD{VIN}^FS
// ^CF0,54
// ^FO50,470^FDFULL VIN :-^FS
// ^FO470,470^FD{VIN}^FS
// ^FO50,560^FDENG NUMBER :-^FS
// ^FO470,560^FD{ENGINE_NUMBER}^FS
// ^FO50,630^FDMODEL :-^FS
// ^FO470,630^A0N,36,36^FD{MODEL}^FS^CF0,54
// ^FO50,740^FDCOLOR :-^FS
// ^FO470,740^FD{COLOR}^FS
// ^FO50,830^FDTYPE OF SALE :-^FS
// ^FO470,830^FDSOLD^FS
// ^FO760,890^FD{MONTH_YEAR}^FS
// ^FO50,960^A0N,30,30^FDDISTRIBUTER :-^FS
// ^FO470,960^A0N,30,30^FDTATA MOTORS PASSENGER VEHICLES^FS
// ^XZ`;
// export const ZPL_TEMPLATE_FOR_WTCL_PRINT = `
// ^XA

// ^PW960
// ^LH0,0

// ^CF0,80

// ^FO50,80^FDPANAPAKKAM OPERATIONS^FS
// ^FO50,180^FDINDIA^FS

// ^BY4,3,120
// ^FO55,290^BCN,120,N,N,N
// ^FD{VIN}^FS

// ^CF0,54

// ^FO50,470^FDFULL VIN :-^FS
// ^FO470,470^FD{VIN}^FS

// ^FO50,560^FDENG NUMBER :-^FS
// ^FO470,560^FD{ENGINE_NUMBER}^FS

// ^FO50,650^FDMODEL :-^FS
// ^FO470,650^FD{MODEL}^FS

// ^FO50,740^FDCOLOR :-^FS
// ^FO470,740^FD{COLOR}^FS

// ^FO50,830^FDTYPE OF SALE :-^FS
// ^FO470,830^FDSOLD^FS
// ^FO760,890^FD{MONTH_YEAR}^FS

// ^FO50,960^A0N,30,30^FDDISTRIBUTER :-^FS
// ^FO470,960^A0N,30,30^FDTATA MOTORS PASSENGER VEHICLES^FS

// ^XZ`;


export const ZPL_TEMPLATE_FOR_WTCL_PRINT_PUNE_JLR = `
^XA

^PW950
^LH0,0

^CF0,70

^FO50,190^FDPUNE OPERATIONS^FS
^FO50,280^FDINDIA^FS

^BY3,3,100
^FO55,380^BCN,180,N,N,N
^FD{VIN}^FS

^CF0,35

^FO50,630^FDFULL VIN :-^FS
^FO270,630^A0N,50,43^FD{VIN}^FS

^FO50,700^FDENG NUMBER :-^FS
^FO310,700^A0N,50,43^FD{ENGINE_NUMBER}^FS

^FO50,770^FDMODEL :-^FS
^FO270,770^FD{MODEL}^FS

^FO50,840^FDCOLOUR :-^FS
^FO270,840^FD{COLOR}^FS

^FO50,910^FDTYPE OF SALE :-^FS
^FO370,910^FDSOLD^FS

^FO50,980^FDMONTH & YEAR :-^FS
^FO350,980^FD{MONTH_YEAR}^FS

^FO50,1050^FDDISTRIBUTER :-^FS
^FO300,1050^FDTATA MOTORS LTD.^FS

^XZ`;

export const TABS = [
	{
		label: 'At Station',
		value: AT_STATION_TAB,
	},
	{
		label: 'Upcoming',
		value: UPCOMING_TAB,
	},
	{
		label: 'Take In-Out',
		value: PROCESSED_TAB,
	},
	{ label: 'Processed', value: NEW_PROCESSED_TAB }


];

export const SORT_STATE = {
	ASCENDING: 'ascending',
	DESCENDING: 'descending',
	UNSORTED: 'unsorted',
};

export const SORTED_STRING = {
	displaySerialNumber: 'displaySerialNumber',

}
export const START_STATE = 'START';
export const COMPELETED_STATE = 'COMPELETED';

export const OPERATIONS = {
	DROP: 'DROP',
	RECEIVE_SN: 'RECEIVE_SN',
	// START_ORDER: 'START_ORDER',
	RECEIVE_PART: 'RECEIVE_PART',
	PART_VALIDATION: 'SCAN',
	PROCESS_VALIDATION: 'SCAN_ATTRIBUTE',
	BOOK: 'BOOK',
	ENGRAVING: 'ENGRAVE',
	MACHINE: 'MACHINE',
	TAKE_IN_OUT: 'TAKE_IN_OUT',
	WTCL: 'WTCL',
	QUALITY: 'QUALITY',
	WCPA: 'WCPA',
	SFLT: 'SFLT',
	BODY_ALIGN: 'BODY_ALIGN',
	WAHA: 'WAHA',
	RBT: 'RBT',
	PAINT_SELECT: 'PAINT_SELECT',
	PRE_CAL: 'PRE_CAL',
	DT: 'DT',
	SHOWER: 'SHOWER',
	TRANSFER_DROP: 'TRANSFER_DROP',
	MAJOR_REPAIR: 'MAJOR_REPAIR',
};

export const OPERATIONS_WITH_PROCESSED_TAB = [
	OPERATIONS.TAKE_IN_OUT,
	OPERATIONS.WTCL,
	OPERATIONS.QUALITY,
	OPERATIONS.WCPA, 
	OPERATIONS.SFLT,
	OPERATIONS.BODY_ALIGN,
	OPERATIONS.WAHA,
	OPERATIONS.RBT,
	OPERATIONS.PAINT_SELECT,
	OPERATIONS.PRE_CAL,
	OPERATIONS.DT,
	OPERATIONS.SHOWER,
	OPERATIONS.BOOK,
	OPERATIONS.MAJOR_REPAIR,
];

export const JLR_LINE_ID = [1014];


export const OPERATIONS_WITH_RECEIVE_PART = [
	OPERATIONS.PART_VALIDATION,
	OPERATIONS.PROCESS_VALIDATION,
	OPERATIONS.BOOK,
	// OPERATIONS.ENGRAVING, // Removed - ENGRAVE can be done directly after RECEIVE_SN
	OPERATIONS.MACHINE,
	OPERATIONS.TAKE_IN_OUT,
	OPERATIONS.WTCL,
	OPERATIONS.QUALITY,
	// OPERATIONS.WCPA, // Removed - WCPA is lot-based, manages its own entry without RECEIVE_PART
	// OPERATIONS.SFLT, // Removed - SFLT is vehicle-list-based, manages its own entry without RECEIVE_PART
	OPERATIONS.BODY_ALIGN,
	OPERATIONS.WAHA,
	OPERATIONS.RBT,
	OPERATIONS.PAINT_SELECT,
	OPERATIONS.PRE_CAL,
	OPERATIONS.DT,
	OPERATIONS.SHOWER,
	OPERATIONS.MAJOR_REPAIR,
];

export const REDIRECT_URLS = {
	[OPERATIONS.DROP]: '/',
	[OPERATIONS.RECEIVE_SN]: '/scan-vin',
	[OPERATIONS.TRANSFER_DROP]: '/transfer-drop',
	// [OPERATIONS.START_ORDER]: '/assembly/vin-validation',
	[OPERATIONS.RECEIVE_PART]: '/assembly/receive-part',
	[OPERATIONS.PART_VALIDATION]: '/assembly/part-validation',
	[OPERATIONS.PROCESS_VALIDATION]: '/assembly/process-validation',
	[OPERATIONS.BOOK]: '/assembly/book',
	[OPERATIONS.ENGRAVING]: '/assembly/engraving',
	[OPERATIONS.MACHINE]: '/assembly/machine',
	[OPERATIONS.TAKE_IN_OUT]: '/assembly/take-in-out',
	[OPERATIONS.WTCL]: '/assembly/wtcl',
	[OPERATIONS.QUALITY]: '/assembly/quality-defect',
	[OPERATIONS.WCPA]: '/assembly/wcpa',
	[OPERATIONS.SFLT]: '/assembly/sflt',
	[OPERATIONS.BODY_ALIGN]: '/assembly/body-align',
	[OPERATIONS.WAHA]: '/assembly/waha',
	[OPERATIONS.RBT]: '/assembly/rbt',
	[OPERATIONS.PAINT_SELECT]: '/assembly/paint-select',
	[OPERATIONS.PRE_CAL]: '/assembly/pre-cal',
	[OPERATIONS.DT]: '/assembly/dt',
	[OPERATIONS.SHOWER]: '/assembly/shower',
	[OPERATIONS.MAJOR_REPAIR]: '/assembly/station/major-repair',
	MAJOR_REPAIR_RECEIVE_PART: '/assembly/major-repair/receive-part',
	MAJOR_REPAIR_RECEIVE_PART_LEGACY: '/assembly/Major-repair/receive-part',
};

export const STEPS = [
	// { operation: OPERATIONS.START_ORDER, label: 'VALIDATE VIN' },
	{ operation: OPERATIONS.TRANSFER_DROP, label: 'TRANSFER DROP' },
	{ operation: OPERATIONS.RECEIVE_SN, label: 'RECEIVE SERIAL NUMBER' },
	{ operation: OPERATIONS.RECEIVE_PART, label: 'RECEIVE PART' },
	{ operation: OPERATIONS.PART_VALIDATION, label: 'PART VALIDATION' },
	{ operation: OPERATIONS.PROCESS_VALIDATION, label: 'PROCESS VALIDATION' },
	{ operation: OPERATIONS.BOOK, label: 'BOOK' },
	{ operation: OPERATIONS.ENGRAVING, label: 'ENGRAVING' },
	{ operation: OPERATIONS.MACHINE, label: 'MACHINE' },
	{ operation: OPERATIONS.TAKE_IN_OUT, label: 'TAKE IN/OUT' },
	{ operation: OPERATIONS.WTCL, label: 'WTCL' },
	{ operation: OPERATIONS.QUALITY, label: 'QUALITY' },
	{ operation: OPERATIONS.WCPA, label: 'WCPA' },
	{ operation: OPERATIONS.SFLT, label: 'SFLT' },
	{ operation: OPERATIONS.BODY_ALIGN, label: 'BODY ALIGN' },
	{ operation: OPERATIONS.WAHA, label: 'WAHA' },
	{ operation: OPERATIONS.RBT, label: 'RBT' },
	{ operation: OPERATIONS.PAINT_SELECT, label: 'PAINT SELECT' },
	{ operation: OPERATIONS.PRE_CAL, label: 'PRE CAL' },
	{ operation: OPERATIONS.DT, label: 'DT' },
	{ operation: OPERATIONS.SHOWER, label: 'SHOWER' },
	{ operation: OPERATIONS.MAJOR_REPAIR, label: 'MAJOR REPAIR' },
];

export const SKIP_PART_REASONS = [
	'DUPLICATE SERIAL NO.',
	'PART MISMATCHED',
	'SERIAL NO. IS BLANK',
	'DAMAGED BARCODE',
	'BARCODE NOT FOUND',
	'OTHER',
];

export const VTS_ATTRIBUTES = [
	"TML PART NO",
	"UIN",
	"IMEI NO",
	"ICCID NO"
]

const classNames = {
	tableContainer: {
		height: '25vh',
	},
	isPartScannedOnce: {
		color: ({ palette }) => palette.error.main,
	},
};

export const DEFAULT_COLUMNS = [
	{
		width: 210,
		title: 'Lot Number',
		field: 'lotNumber',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		align: 'center',
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
	},
	{
		width: 210,
		title: 'ID',
		field: 'displaySequenceNumber',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
		render: (row, theme) => {
			const parts = row.displaySequenceNumber?.split('-') || [];
			return (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						justifyContent: 'center',
					}}
				>
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 'bold',
						}}
					>
						{parts.slice(-2).join('-')}
					</Typography>
				</Box>
			)
		},
	},
	{
		width: 290,
		title: 'KSPEC Number',
		field: 'partNumber',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		align: 'center',
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
	},
	...(window.location.pathname.includes('pune-jlr') ? [{
		width: 300,
		title: 'VIN',
		field: 'serialNumber',
		enableSearch: true,
		enableFilter: true,
		sortable: true,
		align: 'center',
		render: (row, theme) => {
			return (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						justifyContent: 'center',
					}}
				>
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 'bold',
						}}
					>
						{row.serialNumber}
					</Typography>
				</Box>
			)
		},
	}] : []),
	{
		width: 400,
		title: window.location.pathname.includes('pune-jlr') ? 'Model' : 'KSPEC Description',
		field: window.location.pathname.includes('pune-jlr') ? 'model' : 'description',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		align: 'center',
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
	},

	{
		width: 170,
		title: window.location.pathname.includes('pune-jlr') ? 'Model Year' : 'Date',
		field: window.location.pathname.includes('pune-jlr') ? 'modelYear' : 'productionDt',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
		render: (row, theme) => {
			return (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						justifyContent: 'center',
					}}
				>
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 'bold',
						}}
					>
						{window.location.pathname.includes('pune-jlr') ? row.modelYear : row.productionDt}
					</Typography>
				</Box>
			)
		},

	},
];

export const MACHINE_DEFAULT_COLUMNS = [
	{
		width: 210,
		title: 'Lot Number',
		field: 'lotNumber',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		align: 'center',
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
	},
	{
		width: 300,
		title: 'VIN',
		field: 'serialNumber',
		render: (row, theme) => {
			return (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						justifyContent: 'center',
					}}
				>
					{row.serialNumber}

				</Box>
			);
		},
	},
	{
		width: 290,
		title: 'KSPEC Number',
		field: 'partNumber',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		align: 'center',
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
		// render: (row, theme) => {
		// 		return (
		// 			<Box
		// 			sx={{
		// 				display: 'flex',
		// 				alignItems: 'center',
		// 				gap: 1,
		// 				justifyContent: 'center',
		// 			}}
		// 		>
		// 			<Typography
		// 				sx={{
		// 					fontFamily: "'Uni Neue', sans-serif",
		// 					fontWeight: 'bold',
		// 				}}
		// 			>
		// 				{row.partNumber}
		// 			</Typography>
		// 		</Box>
		// 		)
		// },
	},
	{
		width: 400,
		title: window.location.pathname.includes('pune-jlr') ? 'Model' : 'KSPEC Description',
		field: window.location.pathname.includes('pune-jlr') ? 'model' : 'description',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		align: 'center',
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
	},

	{
		width: 170,
		title: window.location.pathname.includes('pune-jlr') ? 'Model Year' : 'Date',
		field: window.location.pathname.includes('pune-jlr') ? 'modelYear' : 'productionDt',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
		render: (row, theme) => {
			return (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						justifyContent: 'center',	
					}}
				>
					<Typography
						sx={{
							fontFamily: "'Uni Neue', sans-serif",
							fontWeight: 'bold',
						}}
					>
						{window.location.pathname.includes('pune-jlr') ? row.modelYear : row.productionDt}
					</Typography>
				</Box>
			)
		},

	},
];

export const ADDITIONAL_COLUMNS_FOR_CHASSIS_LINE = [
	{
		width: 210,
		title: 'Major Model',
		field: 'majorModel',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
	},
	{
		width: 210,
		title: 'Country',
		field: 'country',
		enableSearch: false,
		enableFilter: false,
		sortable: true,
		columnStyle: ({ isVinScannedOnce }) =>
			isVinScannedOnce && classNames.isPartScannedOnce,
	}
];

export const OPTIONAL_COLUMNS = [
	{
		width: 150,
		title: 'Shift',
		field: 'shiftLabel',
		sortable: true,
		render: ({ shiftLabel }) => (
			<div style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '2px 8px',
				gap: '10px',
				background: '#242424',
				borderRadius: '8px',
				minWidth: '37.98px',
				height: '30px',
				fontFamily: 'JLR Emeric',
				fontWeight: 400,
				fontSize: '18px',
				lineHeight: '22px',
				color: '#FFFFFF'
			}}>
				{shiftLabel && <span>{shiftLabel}</span>}
			</div>
		),
	},
];

export const JLR_PLANT = 'Pune JLR';

export const WORK_STREAM_TYPE = {
	SEQUENCE: 'SEQUENCE',
	POOL: 'POOL',
};

export const NO_PART_FAMILY = 'no-part-family';

export const BOOKING_INTERLOCK_OVERRIDE = 'BOOKING_INTERLOCK_OVERRIDE';

export const N0_DATA_FOUND = 'No data found'

// Dev mode constants for handling null serial numbers
export const DEV_MODE = true;
export const DEV_SERIAL_NUMBER = 'MAT45754785475';

export const isPuneJlr = () => {
  return (config.PLANT_NAME?.toUpperCase() ?? 'PUNE') === 'PUNE';
};

/**
 * For Pune JLR, VINs starting with "SALC" use MM/T format instead of MM/YY.
 * All other VINs (and non-Pune plants) retain the normal MM/YY format.
 */
export const getOkTagMonthYear = (monthYear, vin) => {
  if (!isPuneJlr() || !vin || !monthYear) return monthYear || '';
  if (vin.toUpperCase().startsWith('SALC')) {
    const month = monthYear.split('/')[0];
    return `${month}/T`;
  }
  return monthYear;
};
